import { render, staticRenderFns } from "./FormAssign.vue?vue&type=template&id=848be048&"
import script from "./FormAssign.vue?vue&type=script&lang=js&"
export * from "./FormAssign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports